package com.example.mystybag.appCore.views.pages

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.togetherWith
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.rememberLazyGridState
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Text
import androidx.compose.material3.pulltorefresh.PullToRefreshBox
import androidx.compose.material3.pulltorefresh.rememberPullToRefreshState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.example.mystybag.appCore.expected.LocationsMapView
import dev.icerock.moko.resources.compose.painterResource
import com.example.mystybag.appCore.logic.pages.HomePageViewModel
import com.example.mystybag.appCore.model.pages.FilterResultsUIState
import com.example.mystybag.appCore.model.pages.HomeViewMode
import com.example.mystybag.appCore.model.pages.BusinessCategory
import com.example.mystybag.common.extensions.Image
import com.example.mystybag.common.extensions.noRippleClickable
import com.example.mystybag.common.extensions.rippleClick
import com.example.mystybag.common.extensions.scrollEdgeFade
import com.example.mystybag.common.ui.components.custom.ShimmerAsyncImage
import com.example.mystybag.common.ui.components.custom.SearchTextField
import com.example.mystybag.common.ui.components.custom.ShimmerBrush
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.components.native.Texts.ResizableText
import com.example.mystybag.common.ui.components.native.Texts.StrikeThroughText
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.core.expected.setSoftInputModeOverlay
import com.example.mystybag.core.expected.PlatformHelper
import com.example.mystybag.core.expected.rememberIsWebPortraitLayout
import com.example.mystybag.core.ui.theme.LocalTheme.p2
import com.example.mystybag.core.ui.theme.LocalTheme.p4
import com.example.mystybag.core.ui.theme.LocalTheme.p6
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p10
import com.example.mystybag.core.ui.theme.LocalTheme.p14
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p18
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p30
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.sharedmodels.project.responseModels.HomeTopPickUiModel
import kotlinx.coroutines.delay
import kotlin.math.roundToInt
import com.arkivanov.decompose.extensions.compose.subscribeAsState

@Composable
fun CategoryRow(
    viewModel: HomePageViewModel,
    bagsList : List<HomeTopPickUiModel>,
    title    : String
) {
    // Get businessCategoryId from first bag in list (all bags in category should have same businessCategoryId)
    val businessCategoryId = bagsList.firstOrNull()?.businessCategoryId
    
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = p16),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment     = Alignment.CenterVertically
    ) {
        Texts.TitleMedium(
            text      = title,
            textAlign = TextAlign.Start
        )

        Texts.Label(
            text  = sharedString(SR.strings.see_all),
            color = AppTheme.current.colors.primary,
            modifier = Modifier.clickable {
                viewModel.onSeeAllCategoryClick(businessCategoryId, title, bagsList)
            }
        )
    }

    if (viewModel.uiState.value.isLoading) {   // може да остане така
        BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
            val cardWidth = maxWidth * 0.8f

            LazyRow(
                contentPadding        = PaddingValues(horizontal = p16),
                horizontalArrangement = Arrangement.spacedBy(p12)
            ) {
                items(3) {
                    HomeCardSkeleton(cardWidth = cardWidth)
                }
            }
        }
    } else {
        BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
            val cardWidth = maxWidth * 0.75f

            LazyRow(
                contentPadding        = PaddingValues(horizontal = p16),
                horizontalArrangement = Arrangement.spacedBy(p12)
            ) {
                items(bagsList, key = { it.id }) { item ->
                    HomeTopPickCard(
                        model            = item,
                        modifier         = Modifier.width(cardWidth),
                        cardWidth        = cardWidth,
                        onClick          = { viewModel.onTopPickClick(item) },
                        onFavouriteClick = { viewModel.onFavouriteClick(item) }
                    )
                }
            }
        }
    }
}

@Composable
internal fun ActiveFilterChipsRow(
    filterTypes: List<FilterResultsUIState.ActiveFilterType>,
    onClearChip: (FilterResultsUIState.ActiveFilterType) -> Unit
) {
    val colors = AppTheme.current.colors
    val chipLabel: (FilterResultsUIState.ActiveFilterType) -> String = { type ->
        when (type) {
            FilterResultsUIState.ActiveFilterType.DISTANCE -> sharedString(SR.strings.distance)
            FilterResultsUIState.ActiveFilterType.RATING -> sharedString(SR.strings.merchant_rating)
            FilterResultsUIState.ActiveFilterType.PRICE -> sharedString(SR.strings.price_range)
            FilterResultsUIState.ActiveFilterType.LOCATION -> sharedString(SR.strings.filter_by_location)
            FilterResultsUIState.ActiveFilterType.PUBLISHED_DATE -> sharedString(SR.strings.offer_published_date)
            FilterResultsUIState.ActiveFilterType.COLLECTION_TIME -> sharedString(SR.strings.collection_time)
        }
    }
    LazyRow(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        items(filterTypes, key = { it }) { type ->
            Row(
                modifier = Modifier
                    .clip(RoundedCornerShape(20.dp))
                    .background(colors.primary)
                    .padding(start = 12.dp, end = 4.dp, top = 6.dp, bottom = 6.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(4.dp)
            ) {
                Texts.BodyMedium(
                    text = chipLabel(type),
                    color = colors.surface,
                    maxLines = 1
                )
                Box(
                    modifier = Modifier
                        .size(24.dp)
                        .noRippleClickable { onClearChip(type) },
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = "×",
                        color = colors.surface,
                        fontSize = 18.sp
                    )
                }
            }
        }
    }
}

@Composable
internal fun CategoryFilterRow(
    selectedCategory: BusinessCategory,
    onCategorySelected: (BusinessCategory) -> Unit
) {
    val categories: List<Pair<BusinessCategory, String>> = listOf(
        BusinessCategory.ALL to sharedString(SR.strings.all),
        BusinessCategory.BAKERY to sharedString(SR.strings.business_category_bakery),
        BusinessCategory.CONFECTIONERY to sharedString(SR.strings.business_category_confectionery),
        BusinessCategory.FOOD_FOR_HOME to sharedString(SR.strings.business_category_food_for_home),
        BusinessCategory.FISH_MARKET to sharedString(SR.strings.business_category_fish_market)
    )
    val colors = AppTheme.current.colors
    val selectedTextColor = colors.primary
    // Неизбран: onSurfaceVariant; изричен тъмносив резерв за видимост на бял фон (филтърът е винаги на Color.White)
    val unselectedTextColor = colors.onSurfaceVariant.copy(alpha = 1f)


    LazyRow(
        modifier = Modifier
            .fillMaxWidth()
            .height(54.dp)
            .background(AppTheme.current.colors.background),
        contentPadding = PaddingValues(horizontal = 0.dp),
        horizontalArrangement = Arrangement.spacedBy(0.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        items(categories, key = { it.first }) { (category, name) ->
            val isSelected = selectedCategory == category
            val textColor = if (isSelected) colors.primary else unselectedTextColor
            Box(
                modifier = Modifier
                    .rippleClick { onCategorySelected(category) }
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxHeight(),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.SpaceBetween
                ) {
                    if (isSelected) {
                        Texts.UnderlinedText(text = name, color = textColor, maxLines = 1, textDecoration = TextDecoration.Underline)
                    } else {
                        Texts.TitleMedium(text = name, color = textColor, maxLines = 1)
                    }
                }
            }
        }
    }
}

@Composable
internal fun ViewModeFAB(
    isListMode: Boolean,
    onToggle: () -> Unit
) {
    // Figma: Extended FAB 93x48, Primary variant, cornerRadius 51, padding 12,12,20,12, itemSpacing 8
    val fabColors = AppTheme.current.colors
    Row(
        modifier = Modifier
            .clip(RoundedCornerShape(51.dp))
            .background(fabColors.inversePrimary)
            .clickable { onToggle() }
            .padding(start = 12.dp, top = 12.dp, end = 20.dp, bottom = 12.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        Image(
            painter = painterResource(
                if (isListMode) SRC.images.home_view_map else SRC.images.home_view_grid
            ),
            modifier = Modifier.size(20.dp),
            colorFilter = ColorFilter.tint(fabColors.onPrimary)
        )
        Texts.TitleMedium(
            text  = if (isListMode) sharedString(SR.strings.map) else sharedString(SR.strings.list),
            color = fabColors.onPrimary
        )
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun HomePageView(
    viewModel: HomePageViewModel
) {
    // Web desktop: split map + grid. Web portrait (narrow): same flow as Android/iOS (list/map toggle, no side-by-side).
    if (PlatformHelper.isWeb && !rememberIsWebPortraitLayout()) {
        HomePageWebView(viewModel = viewModel)
        return
    }
    // ✅ Decompose Value -> subscribeAsState (НЕ collectAsState)
    val uiState by viewModel.uiState.subscribeAsState()

    // ✅ Search text идва от ChildViewModel.searchControls.state.searchText (Flow)
    // Това гарантира recomposition при писане.
    val searchText by viewModel.searchControls.state.searchText.collectAsState()

    val refreshState = rememberPullToRefreshState()
    val selectedLocationsForSheet = uiState.selectedLocationsForSheet
    val listState = rememberLazyGridState()
    val gridColumns = 2
    val layoutInfo = listState.layoutInfo
    val rowHeightPx = layoutInfo.visibleItemsInfo.firstOrNull()?.size?.height?.toFloat() ?: 260f
    val scrollOffsetPx = (listState.firstVisibleItemIndex / gridColumns) * rowHeightPx + listState.firstVisibleItemScrollOffset
    val scrollProgress = when {
        uiState.viewMode != HomeViewMode.LIST -> 0f
        uiState.gridItemsForGrid.isEmpty() && !uiState.isLoading -> 0f
        else -> (scrollOffsetPx / 120f).coerceIn(0f, 1f)
    }
    val animatedProgress by animateFloatAsState(
        targetValue = scrollProgress,
        animationSpec = tween(durationMillis = 200, easing = FastOutSlowInEasing),
        label = "tabsProgress"
    )

    DisposableEffect(Unit) {
        setSoftInputModeOverlay(overlay = true)
        onDispose { setSoftInputModeOverlay(overlay = false) }
    }
    LaunchedEffect(Unit) {
        delay(150)
        setSoftInputModeOverlay(overlay = true)
    }

    UIView(
        viewModel               = viewModel,
        removeVerticalPadding   = true,
        navigationContent       = null,
        showTopBar              = false,
        applyBottomInsetSpacer  = false
    ) { wrapper ->

        Column(
            modifier = Modifier
                .fillMaxSize()
                .background(AppTheme.current.colors.background)
        ) {
            // Frame 102: 392px content, padding 10dp horizontal, itemSpacing 16
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 10.dp, vertical = 16.dp),
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                // Search row: Search 316dp + 20dp spacing + Filter/Settings 48dp (Figma)
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(20.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    SearchTextField(
                        modifier = Modifier
                            .weight(1f)
                            .widthIn(max = 316.dp),
                        searchCallbacks = viewModel.searchControls,
                        searchHint = sharedString(SR.strings.search_products_and_places)
                    )
                    Box(
                        modifier = Modifier
                            .size(48.dp)
                            .clip(CircleShape)
                            .background(AppTheme.current.colors.surfaceContainerLowest)
                            .rippleClick { viewModel.onFilterClick() },
                        contentAlignment = Alignment.Center
                    ) {
                        Image(
                            painter = painterResource(SRC.images.settings_icon),
                            modifier = Modifier.size(20.dp),
                            colorFilter = ColorFilter.tint(AppTheme.current.colors.primary)
                        )
                    }
                }

                // Active filter chips: under search, above category tabs
                uiState.appliedFilter?.let { filter ->
                    val activeTypes = filter.activeFilterTypes()
                    if (activeTypes.isNotEmpty()) {
                        ActiveFilterChipsRow(
                            filterTypes = activeTypes,
                            onClearChip = viewModel::clearFilterChip
                        )
                    }
                }

                // Tabs: височина и прозрачност синхронизирани със скрола на грида
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(54.dp * (1f - animatedProgress))
                        .clip(RoundedCornerShape(0.dp))
                        .graphicsLayer { alpha = 1f - animatedProgress }
                ) {
                    CategoryFilterRow(
                        selectedCategory = uiState.selectedCategory,
                        onCategorySelected = viewModel::onCategorySelected
                    )
                }
            }

            // Съдържание (списък или карта) + бутон за смяна долу централно
            Box(modifier = Modifier.fillMaxWidth().weight(1f)) {
                AnimatedContent(
                    targetState = uiState.viewMode,
                    transitionSpec = { fadeIn(tween(220)) togetherWith fadeOut(tween(220)) },
                    modifier = Modifier.fillMaxSize(),
                    label = "list_map_transition"
                ) { mode ->
                    if (mode == HomeViewMode.LIST) {
                        PullToRefreshBox(
                            isRefreshing = uiState.refreshing,
                            onRefresh = viewModel::onRefresh,
                            state = refreshState,
                            modifier = Modifier.fillMaxSize()
                        ) {
                            // Figma: Screen Content 380x768, itemSpacing 12; Row 380x248, itemSpacing 8; Merchant Card 186x248
                            if (uiState.isLoading) {
                                LazyVerticalGrid(
                                    state = listState,
                                    columns = GridCells.Fixed(gridColumns),
                                    modifier = Modifier
                                        .fillMaxSize()
                                        .padding(horizontal = 6.dp)
                                        .scrollEdgeFade(
                                            showTop = false,
                                            edgeSize = 14.dp,
                                            overlayColor = AppTheme.current.colors.background.copy(alpha = 0.65f)
                                        ),
                                    contentPadding = PaddingValues(top = 0.dp, bottom = 80.dp),
                                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                                    verticalArrangement = Arrangement.spacedBy(12.dp)
                                ) {
                                    items(6) { HomeCardSkeleton(cardWidth = 186.dp) }
                                }
                            } else {
                                if (uiState.gridItemsForGrid.isEmpty()) {
                                    Box(
                                        modifier = Modifier.fillMaxSize(),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        Texts.BodyLarge(
                                            text = sharedString(SR.strings.no_bags_found),
                                            color = AppTheme.current.colors.onSurfaceVariant,
                                            textAlign = TextAlign.Center
                                        )
                                    }
                                } else {
                                    LazyVerticalGrid(
                                        state = listState,
                                        columns = GridCells.Fixed(gridColumns),
                                        modifier = Modifier
                                            .fillMaxSize()
                                            .padding(horizontal = 6.dp)
                                            .scrollEdgeFade(
                                                showTop = false,
                                                edgeSize = 14.dp,
                                                overlayColor = AppTheme.current.colors.background.copy(alpha = 0.65f)
                                            ),
                                        contentPadding = PaddingValues(top = 0.dp, bottom = 80.dp),
                                        horizontalArrangement = Arrangement.spacedBy(8.dp),
                                        verticalArrangement = Arrangement.spacedBy(12.dp)
                                    ) {
                                        items(uiState.gridItemsForGrid, key = { it.id }) { item ->
                                            HomeTopPickCard(
                                                model = item,
                                                modifier = Modifier.fillMaxWidth().aspectRatio(186f / 248f),
                                                cardWidth = 186.dp,
                                                onClick = { viewModel.onTopPickClick(item) },
                                                onFavouriteClick = { viewModel.onFavouriteClick(item) }
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                    // 🗺️ Map режим БЕЗ PullToRefresh - заема цялата ширина на екрана
                    LocationsMapView(
                        modifier = Modifier
                            .fillMaxSize()
                            .clip(RoundedCornerShape(16.dp)),
                        items = uiState.mapItems,
                        searchQuery = searchText,
                        userLatitude = uiState.userLatitude,
                        userLongitude = uiState.userLongitude,
                        onSearchQueryChange = viewModel.searchControls::onSearchTextChanged,
                        onLocationClick = viewModel::onLocationClick,
                        onLocationCardClick = viewModel::onLocationDialogTap,
                        onClusterClick = { locations -> viewModel.onLocationsAtSameAddress(locations) },
                        selectedItemId = uiState.selectedLocationsForSheet.firstOrNull()?.id
                    )
                    }
                }
                // Замъгляване на картата с черно (подходяща алфа), когато долният списък с торби е показан; tap маха оверлея и списъка
                if (uiState.viewMode == HomeViewMode.MAP && selectedLocationsForSheet.isNotEmpty()) {
                    Box(
                        modifier = Modifier
                            .fillMaxSize()
                            .background(Color.Black.copy(alpha = 0.4f))
                            .clickable { viewModel.onDismissLocationBottomSheet() }
                    )
                }
                Box(
                    modifier = Modifier
                        .align(Alignment.BottomCenter)
                        .padding(bottom = 24.dp)
                ) {
                    ViewModeFAB(
                        isListMode = uiState.viewMode == HomeViewMode.LIST,
                        onToggle = {
                            viewModel.onViewModeSelected(
                                if (uiState.viewMode == HomeViewMode.LIST) HomeViewMode.MAP else HomeViewMode.LIST
                            )
                        }
                    )
                }

                // Location details – horizontal list at bottom (above FAB "Карта/Списък", near tabs)
                if (uiState.viewMode == HomeViewMode.MAP && selectedLocationsForSheet.isNotEmpty()) {
                    Box(
                        modifier = Modifier
                            .align(Alignment.BottomCenter)
                            .fillMaxWidth()
                            .padding(bottom = p12)
                    ) {
                        BoxWithConstraints(
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            val cardWidth = maxWidth * 0.85f
                            LazyRow(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.spacedBy(p12),
                                contentPadding = PaddingValues(horizontal = p16, vertical = p16),
                                userScrollEnabled = true
                            ) {
                                items(selectedLocationsForSheet, key = { it.id }) { location ->
                                    Box(
                                        modifier = Modifier
                                            .width(cardWidth)
                                            .clip(RoundedCornerShape(p24))
                                            .background(AppTheme.current.colors.surface)
                                            .clickable {
                                                viewModel.onLocationDialogTap(location)
                                            }
                                    ) {
                                        Box(modifier = Modifier.fillMaxWidth().padding(p12)) {
                                            LocationDetailsBottomSheet(
                                                location = location,
                                                viewModel = viewModel,
                                                onDismiss = { viewModel.onDismissLocationBottomSheet() },
                                                onViewActiveBagsClick = {
                                                    viewModel.onLocationDialogTap(location)
                                                },
                                                showCloseButton = false,
                                                enableInternalScroll = false
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}


@Composable
internal fun LocationDetailsBottomSheet(
    location: HomeTopPickUiModel,
    viewModel: HomePageViewModel,
    onDismiss: () -> Unit,
    onViewActiveBagsClick: () -> Unit,
    showCloseButton: Boolean = true,
    /** When false, the white card has no internal scroll – it is a fixed element in the horizontal list. */
    enableInternalScroll: Boolean = true
) {
    val (totalActiveBags, pricePair) = viewModel.getLocationActiveBagsInfo(location.merchantLocationId)
    val (priceNormal, priceWithDiscount) = pricePair
    val colors = AppTheme.current.colors
    val typography = AppTheme.current.typography

    Box(
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .then(
                    if (enableInternalScroll) Modifier.verticalScroll(rememberScrollState())
                    else Modifier
                )
        ) {
            // Main content: image left (100x116, rounded 10dp) + text block right; 16dp от картинка до краищата на диалога (горе, ляво, долу)
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(p16),
                verticalAlignment = Alignment.CenterVertically
            ) {
            // Image with optional rating overlay

            Box(
                modifier = Modifier
                    .width(100.dp)
                    .height(116.dp)
                    .clip(RoundedCornerShape(p10))
            ) {
                if (location.locationCoverUrl != null) {
                    ShimmerAsyncImage(
                        modifier = Modifier.fillMaxSize(),
                        link = location.locationCoverUrl,
                        placeholder = null,
                        useOriginalSize = false,
                        contentScale = ContentScale.Crop
                    )
                    if (location.rating > 0.0) {
                        Box(
                            modifier = Modifier
                                .align(Alignment.TopStart)
                                .padding(p4)
                                .clip(RoundedCornerShape(p4))
                                .background(Color.Black.copy(alpha = 0.48f))
                                .padding(horizontal = p4, vertical = p6)
                        ) {
                            Row(
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.spacedBy(p2)
                            ) {
                                Image(
                                    painter = painterResource(SRC.images.home_top_pick_star),
                                    modifier = Modifier.size(16.dp),
                                    colorFilter = ColorFilter.tint(Color.White)
                                )
                                Texts.BodySmall(
                                    text = com.example.mystybag.core.expected.format("%.1f", location.rating),
                                    color = Color.White
                                )
                            }
                        }
                    }
                }
            }

            // Text block: 4 lines (distance, active offers, collect, price) – full width
            Column(
                modifier = Modifier
                    .weight(1f)
                    .fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(p4)
            ) {
                ResizableText(
                    text = location.title,
                    style = typography.titleMedium,
                    color = colors.onSurface,
                    minSize = 10.sp,
                    modifier = Modifier.fillMaxWidth()
                )
                if (location.subtitle.isNotEmpty()) {
                    ResizableText(
                        text = location.subtitle,
                        style = typography.bodyLarge,
                        color = colors.onSurface,
                        minSize = 10.sp,
                        modifier = Modifier.fillMaxWidth()
                    )
                }
                if (location.distance.isNotEmpty()) {
                    ResizableText(
                        text = sharedString(SR.strings.distance) + " " + location.distance,
                        style = typography.bodySmall,
                        color = colors.onSurfaceVariant,
                        minSize = 10.sp,
                        modifier = Modifier.fillMaxWidth()
                    )
                }
                if (location.collectInfo.isNotEmpty()) {
                    ResizableText(
                        text = location.collectInfo,
                        style = typography.bodySmall,
                        color = colors.onSurfaceVariant,
                        minSize = 10.sp,
                        modifier = Modifier.fillMaxWidth()
                    )
                }
                if (location.rating > 0.0 && location.locationCoverUrl == null) {
                    ResizableText(
                        text = sharedString(SR.strings.average_rating_colon, com.example.mystybag.core.expected.format("%.1f", location.rating)),
                        style = typography.bodySmall,
                        color = colors.onSurfaceVariant,
                        minSize = 10.sp,
                        modifier = Modifier.fillMaxWidth()
                    )
                }
                // Price: priceNormal зачертана (ако я има), priceWithDiscount в зелено
                when {
                    priceNormal != null && priceWithDiscount != null -> {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(end = p16),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            ResizableText(
                                modifier = Modifier
                                    .padding(end = p8),
                                text = priceNormal,
                                style = typography.bodySmall.copy(textDecoration = TextDecoration.LineThrough),
                                color = colors.onSurfaceVariant,
                                minSize = 10.sp
                            )
                            ResizableText(
                                text = priceWithDiscount,
                                style = typography.titleMedium.copy(textAlign = TextAlign.End),
                                color = colors.primary,
                                minSize = 10.sp
                            )
                        }
                    }
                }
            }
        }

        }

        // Close button only when not drawn by parent (e.g. in dialog it is drawn on map)
        if (showCloseButton) {
            Box(
                modifier = Modifier
                    .align(Alignment.TopEnd)
                    .shadow(4.dp, CircleShape)
                    .size(p30)
                    .clip(CircleShape)
                    .background(colors.surface)
                    .rippleClick { onDismiss() },
                contentAlignment = Alignment.Center
            ) {
                Image(
                    painter = painterResource(SRC.images.close_button),
                    modifier = Modifier.size(12.dp)
                )
            }
        }
    }
}

@Composable
internal fun HomeTopPickCard(
    model: HomeTopPickUiModel,
    modifier: Modifier = Modifier,
    cardWidth: Dp,
    onClick: () -> Unit,
    onFavouriteClick: () -> Unit,
    showFavoriteButton: Boolean = true
) {
    // Figma: Merchant Card 186x248, cornerRadius 24, padding 16, itemSpacing 10
    Box(
        modifier = modifier
            .clip(RoundedCornerShape(p24))
            .noRippleClickable { onClick() }
    ) {
ShimmerAsyncImage(
            modifier     = Modifier.fillMaxSize(),
            link         = model.locationCoverUrl,
            placeholder  = null,
            useOriginalSize = false,
            contentScale = ContentScale.Crop
        )

        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(
                    brush = Brush.verticalGradient(
                        colors = listOf(
                            Color.Transparent,
                            Color.Black.copy(alpha = 0.15f),
                            Color.Black.copy(alpha = 0.5f),
                            Color.Black.copy(alpha = 0.88f)
                        )
                    )
                )
        )

        // Figma: Merchant Card padding 16, Content itemSpacing 10; top row then Info at bottom
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(p16),
            verticalArrangement = Arrangement.SpaceBetween
        ) {
            // Figma: Frame 135375 154x24, itemSpacing 15; Rating 44x24 pill; Group 16 (heart) 24x24
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(
                    verticalArrangement = Arrangement.spacedBy(p6),
                    horizontalAlignment = Alignment.Start
                ) {
                    RatingBadge(
                        rating     = model.rating,
                        reviewCount = model.reviewCount,
                        modifier   = Modifier
                    )
                    if (model.isSellingFast) {
                        SellingFastBadge()
                    }
                }
                if (showFavoriteButton) {
                    val heartRes = if (model.isFavorite) SRC.images.nav_favorites else SRC.images.home_top_pick_heart
                    val heartTint = if (model.isFavorite) ColorFilter.tint(AppTheme.current.colors.onPrimaryContainer) else null
                    Box(
                        modifier = Modifier
                            .size(24.dp)
                            .clip(CircleShape)
                            .background(Color.White)
                            .noRippleClickable { onFavouriteClick() },
                        contentAlignment = Alignment.Center
                    ) {
                        Image(
                            painter = painterResource(heartRes),
                            modifier = Modifier.size(14.dp),
                            colorFilter = heartTint
                        )
                    }
                }
            }

            // Info at bottom: same spacing from title→type as from pickup hours→price
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = p10),
                verticalArrangement = Arrangement.spacedBy(p4)
            ) {
                // Merchant Name (location name), 2 lines – no min height so spacing matches below
                Texts.BodyLarge(
                    text     = model.title,
                    color    = Color.White,
                    maxLines = 2
                )

                // Additional Info – Merchant Type, Collect Time
                Column(verticalArrangement = Arrangement.spacedBy(p2)) {
                    Texts.BodySmall(
                        text    = model.subtitle,
                        color   = Color.White.copy(alpha = 0.8f),
                        maxLines = 1
                    )
                    Texts.BodySmall(
                        text    = model.collectInfo,
                        color   = Color.White.copy(alpha = 0.8f),
                        maxLines = 1
                    )
                }
                // Price – regular (smaller, 80% opacity) + discounted
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(p8)
                ) {
                    StrikeThroughText(
                        text     = model.oldPrice,
                        style    = AppTheme.current.typography.bodySmall,
                        color    = Color.White.copy(alpha = 0.8f),
                        maxLines = 1
                    )
                    Texts.TitleMedium(
                        text     = model.newPrice,
                        color    = AppTheme.current.colors.primary,
                        maxLines = 1
                    )
                }
            }
        }
    }
}

@Composable
private fun SellingFastBadge(modifier: Modifier = Modifier) {
    Box(
        modifier = modifier
            .height(20.dp)
            .clip(RoundedCornerShape(100.dp))
            .background(AppTheme.current.colors.primaryContainer)
            .padding(horizontal = p8),
        contentAlignment = Alignment.Center
    ) {
        Texts.LabelSmall(
            text     = sharedString(SR.strings.selling_fast),
            color    = AppTheme.current.colors.onPrimaryContainer,
            maxLines = 1
        )
    }
}

@Composable
public fun RatingBadge(
    rating: Double,
    reviewCount: Int?,
    modifier: Modifier = Modifier
) {
    if (rating <= 0.0) return
    val ratingText = ((rating * 10).roundToInt() / 10.0).toString()
    // Figma: Rating 44x24, cornerRadius 100 (pill), padding left=4 top=4 right=6 bottom=4, itemSpacing 2, Star 12dp
    Row(
        modifier = modifier
            .clip(RoundedCornerShape(100.dp))
            .background(Color.Black.copy(alpha = 0.6f))
            .padding(start = p4, top = p4, end = p6, bottom = p4),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(p2)
    ) {
        Image(
            painter = painterResource(SRC.images.home_top_pick_star),
            modifier = Modifier.size(12.dp)
        )
        Texts.BodyMedium(
            text     = ratingText,
            color    = Color.White,
            maxLines = 1
        )
    }
}

@Composable
private fun DotSeparator(modifier: Modifier = Modifier) {
    Box(
        modifier = modifier
            .size(4.dp)
            .clip(CircleShape)
            .background(AppTheme.current.colors.onSurfaceVariant)
    )
}

@Composable
internal fun HomeCardSkeleton(cardWidth: Dp) {
    Column(
        modifier = Modifier
            .width(cardWidth)
            .clip(RoundedCornerShape(p16))
            .background(AppTheme.current.colors.surface)
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(cardWidth * 0.6f)
                .background(ShimmerBrush(showShimmer = true))
        )

        Column(
            modifier = Modifier.padding(all = p12)
        ) {
            Spacer(
                modifier = Modifier
                    .height(p18)
                    .fillMaxWidth(0.8f)
                    .clip(RoundedCornerShape(p8))
                    .background(ShimmerBrush(showShimmer = true))
            )

            Spacer(
                modifier = Modifier
                    .padding(top = p6)
                    .height(p14)
                    .fillMaxWidth(0.5f)
                    .clip(RoundedCornerShape(p8))
                    .background(ShimmerBrush(showShimmer = true))
            )

            Spacer(
                modifier = Modifier
                    .padding(top = p12)
                    .height(p14)
                    .fillMaxWidth(0.9f)
                    .clip(RoundedCornerShape(p8))
                    .background(ShimmerBrush(showShimmer = true))
            )

            Spacer(
                modifier = Modifier
                    .padding(top = p12)
                    .height(p18)
                    .fillMaxWidth(0.6f)
                    .clip(RoundedCornerShape(p8))
                    .background(ShimmerBrush(showShimmer = true))
            )
        }
    }
}
